
export const firstNameRegex = /^[a-zA-Z ]{3,}$/;
export const lastNameRegex = /^[a-zA-Z ]{1,}$/;
export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
